export const PHONE_REGEX = /^[0-9]{10}$/
export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
export const NUMBERS_ONLY = /^[0-9]*$/
export const PERCENTAGE_REGEX = /^100$|^([0-9]|[1-9][0-9])$/